import { ThemeOptions } from "@mui/material";

export const muiLink: ThemeOptions["components"] = {
  MuiLink: {
    styleOverrides: {
      root: ({ theme }) => ({
        color: theme.palette.typography.link,
        textDecoration: "none",
        cursor: "pointer",
        textTransform: "none",
      }),
    },
  },
};
